<!-- <section class="b-color">
  <div
    class="container-div w-100 d-flex justify-content-between align-items-center"
  >
    <div>
      <h3 class="edit-word">STAY INFORMED</h3>
    </div>
    <div class>
      <input class="edit-input" type="email" placeholder="YOUR EMAIL ADDRESS" />
      <button class="edit-sub">SUBSCRIBE</button>
    </div>
  </div>
</section> -->
<section class="b-color" [ngStyle]="{'direction':lang==='ar' ? 'rtl' : 'ltr' }">
  <div
    class="container container-edit subscribe-container h-100"
  >
    <div>
      <h3 class="edit-word">{{'STAY-INFORMED'|translate}}</h3>
    </div>
    <div class>
      <form #heroForm="ngForm" (ngSubmit)="onSubmit(heroForm)">
        <input
          class="edit-input"
          [(ngModel)]="userModel.email"
          maxlength="256"
          name="email"
          type="email"
          #email="ngModel"
          required
          email
          [placeholder]="'YOUR EMAIL ADDRESS' | translate"
        />
        <input
          type="submit"
          [value]="'subscribe' | translate"
          class="edit-sub"
          [ngClass]="{ disabled: !email.valid }"
          [disabled]="!email.valid"
        />
      </form>
      <!--
      <div class="success-message" *ngIf="submited">
        <div>Thank you! Your submission has been received!</div>
      </div> -->
      <div class="error-message" *ngIf="!email.valid && email.touched">
        <div *ngIf="email.errors?.['required']">
          {{'field-required'|translate}}
        </div>
        <div *ngIf="email.errors?.['email']">{{'email-verify'|translate}}</div>
      </div>
    </div>
  </div>
</section>
